<template>
  <div class="cursor">
    <div
      class="cursor__container"
    >
      <svg
        class="cursor__polygon polygon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 88 92"
      >
        <path
          class="polygon__line"
          fill="none"
          d="M43.8 1l26.5 8.6 16.4 22.5V60L70.3 82.5l-26.5 8.6-26.4-8.6L1 60V32.1L17.4 9.6z"
        />
        <path
          class="polygon__progress"
          fill="none"
          d="M43.8 1l26.5 8.6 16.4 22.5V60L70.3 82.5l-26.5 8.6-26.4-8.6L1 60V32.1L17.4 9.6z"
        />
      </svg>
      <p
        class="cursor__caption"
        ref="caption"
      ></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppCursor',
};
</script>

<style lang="scss" scoped>
.cursor {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  pointer-events: none;
  z-index: z-index(loader);

  @include mq($and: $is-touch-device) {
    @include visually-hidden;
  }

  &__container {
    position: absolute;
    width: 80px;
    height: 80px;

    .cursor__caption {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: 0;

      color: $color-primary;
      line-height: 80px;
      text-align: center;
      letter-spacing: 2px;
      font-size: 14px;

      opacity: 0;
    }
  }

  .polygon {
    position: relative;
    width: 80px;
    height: 80px;

    &__line {
      stroke: rgba($color-primary, 0.5);
    }

    &__progress {
      stroke: $color-primary;
    }
  }
}
</style>
